export class DbIndex {
    tableName: string;
    name: string;
    isPrimary = false;
    isUnique = false;
    columns: string[];
}
